import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LogoIsotipo } from '../components/Logo';
import api, { formatApiError } from '../lib/api';
import { Users } from 'lucide-react';

export default function JoinFamilyInvite() {
    const navigate = useNavigate();
    const { code } = useParams();
    const [preview, setPreview] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        api.get(`/family/preview/${code}`)
            .then((r) => setPreview(r.data))
            .catch((e) => setError(formatApiError(e)));
    }, [code]);

    const onCreate = () => navigate(`/registro?code=${encodeURIComponent(code)}`);
    const onExisting = () => navigate(`/login?code=${encodeURIComponent(code)}`);

    return (
        <div
            className="fixed inset-0 flex flex-col text-white overflow-y-auto"
            style={{
                background: 'linear-gradient(180deg, #5B5FDB 0%, #4346A3 100%)',
            }}
            data-testid="join-family-invite"
        >
            <div className="flex-1 flex flex-col items-center justify-center px-8 py-12 max-w-md mx-auto w-full">
                <LogoIsotipo size={130} className="mb-6" />

                {error ? (
                    <div className="bg-red-500/20 border border-red-300/60 text-white rounded-2xl p-4 text-center text-sm" data-testid="invite-error">
                        {error}
                    </div>
                ) : preview ? (
                    <div className="text-center fade-up">
                        <p className="text-white/90 text-base mb-1">Te han invitado a formar parte de</p>
                        <h2 className="text-3xl font-bold mb-5">{preview.name}</h2>
                        <div className="w-28 h-28 bg-white/15 rounded-full flex items-center justify-center mx-auto mb-5 border border-white/30">
                            {preview.avatar_url ? (
                                <img src={preview.avatar_url} alt="" className="w-full h-full object-cover rounded-full" />
                            ) : (
                                <Users className="w-12 h-12 text-white/80" />
                            )}
                        </div>
                        <p className="text-white/80 text-sm mb-4">
                            {preview.members_count} miembro{preview.members_count !== 1 && 's'}
                            {preview.created_at && ` · Desde ${new Date(preview.created_at).toLocaleString('es', { month: 'long', year: 'numeric' })}`}
                        </p>
                        <div className="bg-white/15 border border-white/30 rounded-full px-6 py-2 inline-block text-lg font-bold tracking-wider mb-8" data-testid="invite-family-code">
                            {code}
                        </div>
                    </div>
                ) : (
                    <div className="py-10 text-white/80">Cargando invitación...</div>
                )}

                {preview && (
                    <>
                        <div className="w-full flex items-center gap-3 my-3">
                            <div className="flex-1 h-px bg-white/30" />
                            <span className="text-xs text-white/80 font-medium">¿Cómo deseas unirte?</span>
                            <div className="flex-1 h-px bg-white/30" />
                        </div>
                        <div className="w-full space-y-3 fade-up fade-up-delay-1">
                            <button
                                onClick={onCreate}
                                className="w-full h-14 bg-white text-brand-navy rounded-full font-bold text-base shadow-lg hover:scale-[1.01] active:scale-[0.98] transition"
                                data-testid="invite-create-account"
                            >
                                Crear cuenta
                            </button>
                            <button
                                onClick={onExisting}
                                className="w-full h-14 bg-transparent border-2 border-white/60 text-white rounded-full font-bold text-base hover:bg-white/10 active:scale-[0.98] transition"
                                data-testid="invite-existing-account"
                            >
                                Ya tengo cuenta
                            </button>
                        </div>
                    </>
                )}

                <button onClick={() => navigate('/intro')} className="mt-8 text-white/80 hover:text-white text-sm font-medium" data-testid="invite-back-home">
                    Volver al Inicio
                </button>
            </div>
        </div>
    );
}
